// extracted by mini-css-extract-plugin
export default {"help-text":"dOCfQnHAUY0BTPDY7r8g","helpText":"dOCfQnHAUY0BTPDY7r8g"};